/**
 *
 * @param {{[key in string]:boolean}[]} values
 * @returns {string[]} selected options names
 */
export const checkedFiltersToFiltersList = (values = []) =>
  values.reduce((acc = [], value) => {
    if (!value) return acc
    const name = Object.keys(value)[0]
    if (value[name]) acc.push(name)
    return acc
  }, [])